import _objectSpread from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import request from '@/utils/request';
import { API } from '@/settings.js'; // 获取账号列表

export function get_account_list(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'auth/merchant/v1/get_account_list',
    method: 'post',
    data: data
  }, options));
} // 获取账号列表-合并

export function get_account_merge_auth_page(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread(_objectSpread({
    url: API.PREFIX1 + 'auth/merchant/v1/get_account_merge_auth_page',
    method: 'post',
    data: data
  }, options), {}, {
    tabelLoading: true
  }));
} // 获取角色

export function get_role_by_organization_code(params) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'auth/role/v1/get_role_by_organization_code',
    method: 'get',
    params: params
  }, options));
} // 获取详情

export function get_account_info(params) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'auth/merchant/v1/get_account_info',
    method: 'get',
    params: params
  }, options));
} // 详情-查询角色权限

export function get_role_resource_tree(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'auth/merchant/v1/get_role_resource_tree',
    method: 'post',
    data: data
  }, options));
} // 编辑-组织与角色

export function get_role_allot_list(params) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'auth/merchant/v1/get_role_allot_list',
    method: 'get',
    params: params
  }, options));
} // 编辑

export function save_account_info(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'auth/merchant/v1/save_account_info',
    method: 'post',
    data: data
  }, options));
} // 分配角色

export function allot_user_role(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'auth/merchant/v1/allot_user_role',
    method: 'post',
    data: data
  }, options));
} // 检验手机号唯一

export function check_mobile(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'ucc/verification/v1/check_mobile',
    method: 'post',
    data: data
  }, options));
} // 检验账号唯一

export function check_login_account(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return request(_objectSpread({
    url: API.PREFIX1 + 'ucc/verification/v1/check_login_account',
    method: 'post',
    data: data
  }, options));
} // 查询用户状态

export function query_user_state(data) {
  return request({
    url: API.PREFIX2 + 'merchant/v1.0/get/merchant_state',
    method: 'get',
    params: data
  });
} // 获取usersig

export function getUserSig(data) {
  return request({
    url: "/userPortal/ui/im/getUserSig?imUserId=".concat(data.userID),
    method: 'get'
  });
}